import type { RootState } from '../..';

const selectLoadingState = (state: RootState) => state.applicationState.isLoading;

const selectProjectInfoState = (state: RootState) => state.applicationState.projectInfo;

const selectProjectId = (state: RootState) => state.applicationState.projectInfo?.id;

const selectArea = (state: RootState) => state.applicationState?.projectInfo?.area;

const selectContactEmail = (state: RootState) => state.applicationState?.projectInfo?.contactEmail;

const selectContactPhone = (state: RootState) => state.applicationState?.projectInfo?.contactPhone;

const selectDisplayName = (state: RootState) => state.applicationState?.projectInfo?.displayName;

const selectSpaceConfigurator = (state: RootState) =>
  state.applicationState?.projectInfo?.enabledTools?.find((tool) => tool.name === 'SpaceConfigurator');

const selectColiving = (state: RootState) => state.applicationState?.projectInfo?.enabledTools?.find((tool) => tool.name === 'Coliving');

const selectMyAccount = (state: RootState) => state.applicationState?.projectInfo?.enabledTools?.find((tool) => tool.name === 'MyAccount');

const selectHasError = (state: RootState) => state.applicationState.hasError;

const selectSnackbar = (state: RootState) => state.applicationState.snackbar;

const selectAssetTypology = (state: RootState) => state.applicationState?.projectInfo?.rentConstraints?.assetTypology ?? 'apartment';

const selectExternalApi = (state: RootState) => state.applicationState?.projectInfo?.myhomeConfig?.externalApi;

const selectStatuses = (state: RootState) => state.applicationState.statuses;

const selectProjectAssetType = (state: RootState) => {
  const assetTypology = selectAssetTypology(state);
  const area = selectArea(state);
  const experienceType = assetTypology === 'room' ? 'coliving' : 'apartment';
  return { assetTypology, area, experienceType };
};

export const applicationStateSelectors = {
  selectIsLoading: selectLoadingState,
  selectProjectInfo: selectProjectInfoState,
  selectProjectId,
  selectArea,
  selectContactEmail,
  selectContactPhone,
  selectDisplayName,
  selectSpaceConfigurator,
  selectColiving,
  selectMyAccount,
  selectHasError,
  selectSnackbar,
  selectAssetTypology,
  selectExternalApi,
  selectStatuses,
  selectProjectAssetType,
};
